export const SET_USER = 'SET_USER';
export const LOGOUT = 'LOGOUT';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const SELECTED_CLIENT = 'SELECTED_CLIENT';
export const SELECTED_CLIENT_SUCCESS = 'SELECTED_CLIENT_SUCCESS';
